// The hero's backdrop (TOM-980): the approved design's steel trawler silhouette
// and the wave along the hero's foot. Both are decoration and hidden from
// assistive technology. The gradient and shape ids carry a home-boat- prefix
// because SVG ids are global to the document.

export function HomeBoat() {
  return (
    <svg className="home-boat" aria-hidden="true" viewBox="0 0 1000 400">
      <defs>
        <linearGradient id="home-boat-steel" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#4E6B87" />
          <stop offset="0.22" stopColor="#42607C" />
          <stop offset="0.48" stopColor="#30495F" />
          <stop offset="0.62" stopColor="#3B5772" />
          <stop offset="0.82" stopColor="#4A6782" />
          <stop offset="1" stopColor="#334E68" />
        </linearGradient>
        <linearGradient id="home-boat-sheen" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#FFFFFF" stopOpacity="0" />
          <stop offset="0.38" stopColor="#FFFFFF" stopOpacity="0" />
          <stop offset="0.5" stopColor="#B9CDE0" stopOpacity="0.16" />
          <stop offset="0.62" stopColor="#FFFFFF" stopOpacity="0" />
          <stop offset="1" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="home-boat-glass" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2E465D" />
          <stop offset="1" stopColor="#22374B" />
        </linearGradient>
        <g id="home-boat-hull">
          <path d="M50 245 L900 200 L962 190 Q935 268 862 318 Q820 342 700 344 L130 344 Q72 342 56 302 Z" />
          <path d="M165 240 L165 168 L600 158 L688 166 L730 220 Z" />
          <path d="M395 162 L408 106 L660 98 L642 160 Z" />
          <path d="M355 110 L368 90 L640 82 L652 100 Z" />
          <rect x="200" y="130" width="120" height="40" rx="4" />
        </g>
      </defs>
      <use href="#home-boat-hull" transform="translate(5 6)" fill="#24394E" fillOpacity="0.6" />
      <use href="#home-boat-hull" transform="translate(-2 -2)" fill="#6A87A3" fillOpacity="0.55" />
      <use href="#home-boat-hull" fill="url(#home-boat-steel)" />
      <use href="#home-boat-hull" fill="url(#home-boat-sheen)" />
      <g fill="url(#home-boat-glass)">
        <rect x="200" y="184" width="64" height="22" rx="4" />
        <rect x="278" y="182" width="64" height="22" rx="4" />
        <rect x="356" y="180" width="64" height="22" rx="4" />
        <rect x="434" y="178" width="64" height="22" rx="4" />
        <rect x="512" y="176" width="64" height="22" rx="4" />
        <path d="M590 174 L670 174 L690 196 L590 198 Z" />
        <path d="M430 120 L520 117 L516 146 L426 148 Z" />
        <path d="M534 116 L640 112 L630 144 L530 146 Z" />
        <circle cx="260" cy="272" r="8" />
        <circle cx="320" cy="270" r="8" />
        <circle cx="620" cy="262" r="8" />
        <circle cx="680" cy="258" r="8" />
        <path d="M72 318 Q90 326 130 326 L700 326 Q815 324 866 300 L860 310 Q815 336 700 338 L130 338 Q86 338 66 324 Z" />
      </g>
      <path
        d="M50 245 L900 200 L962 190"
        fill="none"
        stroke="#7895B0"
        strokeOpacity="0.7"
        strokeWidth="3"
      />
      <path
        d="M165 168 L600 158 L688 166"
        fill="none"
        stroke="#7895B0"
        strokeOpacity="0.7"
        strokeWidth="2"
      />
    </svg>
  );
}

export function HomeWave() {
  return (
    <svg className="home-wave" aria-hidden="true" viewBox="0 0 1440 90" preserveAspectRatio="none">
      <path
        className="home-wave__sea"
        d="M0 40 C 240 0, 420 0, 660 40 S 1080 80, 1440 30 L1440 90 L0 90 Z"
      />
      <path className="home-wave__line" d="M0 30 C 240 -10, 420 -10, 660 30 S 1080 70, 1440 20" />
    </svg>
  );
}
